import { ArrowLeft01Icon, Button } from "@porchpass/ui";

export const PageBackButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    type="button"
    variant="ghost"
    size="s"
    onClick={onClick}
    aria-label="Back"
    className="flex items-center bg-[#e5ebfd] px-2 py-2 w-8 h-8 hover:bg-[#DDE3F5] md:bg-transparent md:px-4 md:py-2 md:hover:bg-[#e5ebfd] gap-3"
  >
    <ArrowLeft01Icon
      variant="stroke-sharp"
      size={22}
      className="box-content shrink-0"
    />
    <span className="hidden md:inline">Back</span>
  </Button>
);
